import { SelectOption } from '@techmore/form';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map2Label'
})
export class Map2LabelPipe implements PipeTransform {

  transform(value: SelectOption[]|SelectOption): any {
    if (Array.isArray(value)) {
      return value.map(opt => opt.label).join(', ');
    } else {
      return value.label;
    }
  }

}
